import api from "@/axios";
import type { Customer, LinkedProduct } from '@/types/customer-types'
import type { AxiosResponse } from 'axios'

export const getCustomerList = async (): Promise<Customer[]> => {
  const response = await api.get('/customers')
  return response.data
}

export const getCustomerById = async (id: string): Promise<Customer> => {
  const response = await api.get(`/customers/${id}`)
  return response.data
}

export const addCustomer = async (data: Customer): Promise<AxiosResponse> => {
  const response = await api.post('/customers', data)
  return response.data
}

export const editCustomer = async (data: Customer, id: string): Promise<AxiosResponse> => {
  const response = await api.patch(`/customers/${id}`, data)
  return response.data
}

export const addLinkedProductToCustomer = async (
  id: string,
  data: LinkedProduct
): Promise<AxiosResponse> => {
  const response = await api.post(`/customers/${id}/linked-product`, data)
  return response.data
}

export const editLinkedProductForCustomer = async (
  customerId: string,
  data: LinkedProduct,
  linkedProductId?: string
): Promise<AxiosResponse> => {
  const response = await api.put(`customers/${customerId}/linked-product/${linkedProductId}`, data)
  return response.data
}

export const getLinkedProductForCustomer = async (
  customerId: string,
  linkedProductId: string
): Promise<LinkedProduct> => {
  const response = await api.get(`customers/${customerId}/linked-product/${linkedProductId}`)
  return response.data
}

export const deleteLinkedProductForCustomer = async (customerId: string, linkedProductId: string): Promise<AxiosResponse> => {
  const response = await api.delete(`/customers/${customerId}/linkedProducts/${linkedProductId}`)
  return response.data
}